import React, { useRef, useState, useEffect } from "react";

import { Table, TableBody, TableContainer, TableHead, TableRow,
  TextField, Paper, Button, Checkbox, InputAdornment,
  Divider, Menu, MenuItem, TableSortLabel, Snackbar, IconButton
} from "@mui/material";

import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import SearchIcon from "@mui/icons-material/Search";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import RestoreIcon from "@mui/icons-material/Restore";
import CachedIcon from "@mui/icons-material/Cached";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from "@mui/icons-material/Close";
import { obtenerListadoMiembros } from "../service/apiService.js"
import { useNavigate, useLocation } from "react-router-dom";
import { setItems } from "../provider/Slice/MiembrosSlice.js";
import DialogGroup from "../components/adminsuite/DialogGroup.js";

import {
  StyledTableRow,
  StyledTableCell, InputStyle,
  CheckBox, StyleTableSortLabel
} from "../SXStyle";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useAppDispatch, useAppSelector } from "../provider/app/hooks";

export default function UsersGroupAdminSuite() {

  //react-router-doom
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const idUserGroup = queryParams.get("id");
  
  //si no hay parametros redirecciona
  useEffect(() => {
    if (!idUserGroup) navigate("/");
    else cargarListado();
  }, [idUserGroup, navigate]);

  //redux
  const dispatch = useAppDispatch();
  const miembros = useAppSelector((state) => state.StoreMiembros.data);

  const [buscador, setBuscador] = useState("");
  const [data, setData] = useState([]);

  //states del main menu
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  // Estado global para el menú
  const [rowAnchorEl, setRowAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);

  const [registro, setRegistro] = useState();

  const [columnasVisibles, setColumnasVisibles] = useState({
    user_fullname: true,
    inviter_fullname: true,
    grupo_name: true,
    assigned_at: true,
  });

  //order columns
  const [order, setOrder] = useState("asc");            // "asc" o "desc"
  const [orderBy, setOrderBy] = useState("type");       // columna ordenada

  //dialog
  const [openDialog, setOpenDialog] = useState();

  //loader
  const [openLoader, setOpenLoader] = useState(true);

  //snackbar de alertas
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });


  //cierra el snackbar
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };
  
  const abrirMenuColumnas = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //functions del menu table
  const abrirTableMenu = (event, rowId) => {
    setRowAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };

  const cerrarTableMenu = () => {
    setRowAnchorEl(null);
    setMenuRowId(null);
  };

  const abrirEditarRegistro = (row) => {
    setRegistro(row);
    setRowAnchorEl(null);
    setMenuRowId(null);
    setOpenDialog(true);
  }


  const isMenuTableAbierto = (rowId) => {
    return menuRowId === rowId;
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortedData = React.useMemo(
    () => [...data || []].sort(getComparator(order, orderBy)),
    [data, order, orderBy]
  );


  // aplica el filtrado
  useEffect(() => {

    setOpenLoader(true);

    // Activa un loader primero
    setTimeout(() => {
      const resultados = miembros?.filter((item) => {
        const valores = Object.values(item);
        return valores.some((valor) => {
          if (typeof valor === "string" || typeof valor === "number") {
            return valor.toString().toLowerCase().includes(buscador);
          }
          return false;
        });
      });

      setData(resultados);
      setOpenLoader(false);
    }, 300);

  }, [buscador]);

  
  //recarga el listado al sufrir un cambio
  useEffect(() => {
    setOpenLoader(true);
  
    // Activa un loader primero
    setTimeout(() => {
      setData(miembros);
      setOpenLoader(false);
    }, 300);

  }, [miembros]);

  const cargarListado = async () => {
    const response = await obtenerListadoMiembros(idUserGroup);
    dispatch(setItems(response.data));
  }


  const habilitarVisibilidadColumnas = (checked, column) => {
    setColumnasVisibles((prev) => ({
      ...prev,
      [column]: checked,
    }));
  };

  const resetVisilidadColumnas = () => {
    setColumnasVisibles({
      user_fullname: true,
      inviter_fullname: true,
      grupo_name: true,
      assigned_at: true,
    });
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
    );

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="flex flex-col h-[82vh] px-12 py-8 mx-auto ">
        <div className="bg-ceniza_light border border-gray-600 rounded-lg shadow-xl p-5 ml-5 h-[75vh] w-full">
          
          {/* Dialog */}
          <DialogGroup 
            open={openDialog}
            setOpen={setOpenDialog}
            registro={registro}
            setSnackbar={setSnackbar}
          />

          {/* Snackbar */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            message={snackbar.message}
            action={action}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            ContentProps={{
            sx: {
              color: "#fffcfc"
            },
            }}
          />

          {/* Loader */}
          <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={openLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          {/* Accesos Rapidos */}
          <div className="flex justify-end  mt-6 gap-2">
           
            <TextField
              id="buscar"
              label="Buscar"
              size="small"
              defaultValue=""
              className="rounded-lg block w-full bg-inputs border"
              sx={{
                ...InputStyle,
                width: "320px",
                height: "40px",
                marginTop: "12px",
              }}
              onChange={(e) => setBuscador(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className="text-amarillo" fontSize="10" />
                    </InputAdornment>
                  ),
                },
              }}
            />

            {/* Menu de Visibilidad de Columnas */}
            <div>
              <div
                className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
                id="basic-button"
                aria-controls={isMenuOpen ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={isMenuOpen ? "true" : undefined}
                onClick={(e) => abrirMenuColumnas(e)}
              >
                <ViewWeekIcon className="text-amarillo" fontSize="medium" />
              </div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={() => setAnchorEl(null)}
                sx={{ width: "100%", padding: "5px" }}
                slotProps={{
                  list: {
                    "aria-labelledby": "basic-button",
                  },
                }}
              >
                <p className="w-[160px] text-center"> Toggle columns </p>
                <Divider />

                {Object.entries(columnasVisibles).map(([name, value]) => (
                  <div className="flex">
                    <Checkbox
                      checked={value}
                      name={name}
                      sx={CheckBox}
                      onChange={(e) =>
                        habilitarVisibilidadColumnas(e.target.checked, name)
                      }
                    />
                    <MenuItem style={{ pointerEvents: "none" }}>
                      {name}
                    </MenuItem>
                  </div>
                ))}
              </Menu>
            </div>

            <div
              className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
              onClick={resetVisilidadColumnas}
            >
              <RestoreIcon className="text-amarillo" fontSize="medium" />
            </div>

            <div
              className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
              onClick={() => console.log("")}
            >
              <CachedIcon className="text-amarillo" fontSize="medium" />
            </div>
          </div>

          {/* Tabla */}
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "350px", width: "100%", marginTop: "20px" }}
          >
            <Table aria-label="customized table" stickyHeader>
              <TableHead>
                <TableRow>
                  {columnasVisibles.user_fullname && (
                    <StyledTableCell 
                      align="center" 
                      sortDirection={orderBy === 'user_fullname' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'user_fullname'}
                        direction={orderBy === 'user_fullname' ? order : 'asc'}
                        onClick={() => handleRequestSort('user_fullname')}
                        sx={StyleTableSortLabel}
                      >
                        Miembro
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  {columnasVisibles.inviter_fullname && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'inviter_fullname' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'inviter_fullname'}
                        direction={orderBy === 'inviter_fullname' ? order : 'asc'}
                        onClick={() => handleRequestSort('inviter_fullname')}
                        sx={StyleTableSortLabel}
                      >
                        Invitado Por
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  {columnasVisibles.grupo_name && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'grupo_name' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'grupo_name'}
                        direction={orderBy === 'grupo_name' ? order : 'asc'}
                        onClick={() => handleRequestSort('grupo_name')}
                        sx={StyleTableSortLabel}
                      >
                        Grupo
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  {columnasVisibles.assigned_at && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'assigned_at' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'assigned_at'}
                        direction={orderBy === 'assigned_at' ? order : 'asc'}
                        onClick={() => handleRequestSort('assigned_at')}
                        sx={StyleTableSortLabel}
                      >
                        Se unió el
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  <StyledTableCell align="center">
                    <SettingsApplicationsIcon
                      className="text-amarillo"
                      sx={{ fontSize: 30 }}
                    />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((row, index) => (
                  <StyledTableRow key={index}>
                    

                    {columnasVisibles.user_fullname && (
                      <StyledTableCell align="center">
                        {row.user_fullname}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.inviter_fullname && (
                      <StyledTableCell align="center">
                        {row.inviter_fullname}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.grupo_name && (
                      <StyledTableCell align="center">
                        {row.grupo_name}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.assigned_at && (
                      <StyledTableCell align="center">
                        {row.assigned_at}
                      </StyledTableCell>
                    )}

                    <StyledTableCell align="center">
                      <div>
                        <div
                          className="cursor-pointer"
                          aria-controls={
                            isMenuTableAbierto(row.id)
                              ? "basic-menu"
                              : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={
                            isMenuTableAbierto(row.id) ? "true" : undefined
                          }
                          onClick={(e) => abrirTableMenu(e, row.id)}
                        >
                          <MoreHorizIcon
                            className="text-gris"
                            sx={{ fontSize: 25 }}
                          />
                        </div>

                        <Menu
                          id="basic-menu"
                          anchorEl={rowAnchorEl}
                          open={isMenuTableAbierto(row.id)}
                          onClose={() => cerrarTableMenu()}
                          sx={{ width: "100%", padding: "5px" }}
                          slotProps={{
                            list: {
                              "aria-labelledby": "basic-button",
                            },
                          }}
                        >
                          <MenuItem onClick={() => abrirEditarRegistro(row)}>
                            Eliminar
                          </MenuItem>
                        </Menu>
                      </div>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>


        </div>
      </div>
    </section>
  );
}
